import { Player } from './player.ts';
import { Room } from './room.ts';

export class State {
    players: { [key: string]: Player } = {};
    rooms: { [key: string]: Room } = {};
}